import React from 'react';
import { CheckRounded } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { string } from 'prop-types';

import {
  Border,
  Card,
  Cardset,
  Highlights,
} from './styles';
import staticText from '../../../../../../localization/Application/Billing/legacyCard';
import { Banner } from '../../../../../../components';

const LegacyCard = ({ metronomePlanName }) => {
  const planStaticText = staticText[metronomePlanName];

  if (!planStaticText) {
    return null;
  }

  return (
    <Banner severity="info" styles={{ alignItems: 'flex-start', width: 'auto' }}>
      <Typography variant="h2">{planStaticText.heading}</Typography>
      <Typography variant="body2" sx={{ marginTop: 1, width: '800px' }}>{planStaticText.tooltip}</Typography>
      <Cardset>
        <Card>
          <Box display="flex" alignItems="center">
            <Typography variant="h2" sx={{ marginRight: 0.5 }}>
              {planStaticText.pricing}
            </Typography>
            <Typography>
              {planStaticText.pricingAddendum}
            </Typography>
          </Box>
        </Card>
        <Border />
        <Card>
          <Highlights>
            {planStaticText.highlights.map(highlight => (
              <Typography variant="body1" key={highlight.text}>
                <CheckRounded color="success" fontSize="medium" />
                {highlight.text}
              </Typography>
            ))}
          </Highlights>
        </Card>
        <Border />
        <Card>
          <Typography>{planStaticText.feature}</Typography>
        </Card>
      </Cardset>
    </Banner>
  );
};

export default LegacyCard;

LegacyCard.propTypes = {
  metronomePlanName: string.isRequired,
};
